<div class="login">
  <app-sign-in [content]="content" (signInCompleted)="nextPage()"></app-sign-in>
</div>
